import { Skeleton } from "@/shared/ui/skeleton";

export function PageLoader() {
  return (
    <div className="flex h-screen items-center justify-center">
      <Skeleton className="h-8 w-64" />
    </div>
  );
}
